export type GameKey = "RUNESCAPE" | "RUST" | "MINECRAFT";

export const Game: Record<GameKey, string> = {
  RUNESCAPE: "Runescape",
  RUST: "Rust",
  MINECRAFT: "Minecraft",
};
